import * as React from 'react';
import {Meta, Title} from './headTag';
import {imgDomainShareReplacing} from '../../const/code';

export interface IMetaData {
  site_name?;
  type?;
  title;
  description?;
  imageUrl?;
  imageWidth?;
  imageHeight?;
  url?;
  id?;

}

function getShareImg(imgSrc) {
  imgDomainShareReplacing.forEach((v) => {
    imgSrc = imgSrc.replace(v.from, v.to);
  });
  return imgSrc;
}

export function getMetas(og: IMetaData): any[] {
  return [
    <Title key="title">{og.title}</Title>,
    og.site_name && <Meta property="og:site_name" key="og:site_name" content={og.site_name}/>,
    og.type && <Meta property="og:type" key="og:type" content={og.type}/>,
    <Meta property="og:title" key="og:title" content={og.title}/>,
    og.description && <Meta property="og:description" key="og:description" content={og.description}/>,
    <Meta property="og:image" key="og:image" content={og.imageUrl && getShareImg(og.imageUrl) || 'http://img.ucweb.com/s/uae/g/3f/share/share-logo-en.png'}/>,
    og.imageWidth && <Meta property="og:image:width" key="og:image:width" content={og.imageWidth || 176}/>,
    og.imageHeight && <Meta property="og:image:height" key="og:image:height" content={og.imageHeight || 114}/>,
    og.url && <Meta property="og:url" key="og:url" content={og.url}/>,
    og.id && <Meta property="og:id" key="og:id" content={og.id}/>,

  ];
}

export function setMetaInfoForNative(params: {
  url: string;
  seed_icon_desc: string;
  seed_icon_url: string;
  item_id: string;
  title: string;
  img_url: string;
  recoid: string;
  source_name: string;
}) {
  if (window.ucapi) {

    try {
      window.ucapi.alphaNews.loadNewsItem({
        ...params,
        success(data) {
          // window.ucNativeMode = true;
        },
        fail() {
          console.warn('ucapi fail');
        },
      });
    } catch (e) {
      console.error('ucapi loadNewsItem error', e);
    }
  }
}
